import { Box, Typography, Stack, ClickAwayListener, FormControl, Button, RadioGroup, FormControlLabel, Radio, styled, Switch } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState, useEffect, useRef } from "react";
import { Form as RBFORM } from 'react-bootstrap';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getMethod, postMethod } from "../../../../services/apiService";
import { ToastContext, useToastContext } from "../../../../context/toastContext";

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 18,
    height: 11,
    padding: 0,
    display: "flex",
    "&:active": {
        "& .MuiSwitch-thumb": {
            width: "5px",
            height: "5px",
        },
    },
    "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
            transform: "translateX(8px)",
            color: "#1F2F34",
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: "#17B2EB",
                border: "1.32px solid #17B2EB",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        width: "5px",
        height: "5px",
        margin: "1.3px 1px 0 1px",
        borderRadius: 6,
        boxShadow: "none",
        transition: theme.transitions.create(["width"], {
            duration: 300,
        }),
    },
    "& .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "transparent",
        boxSizing: "border-box",
        border: "1.32px solid var(--text-text-tertiary, #A5A8A9)",
        borderRadius: 16 / 2,
    },
}));

const EmailSetup = () => {

    const { setToast } = useToastContext() as ToastContext;
    const [emailServices, setEmailServices] = useState(["SMTP", "OUTLOOK", "GMAIL", "AWS"]);
    const [rolesVisible, setRolesVisible] = useState(false);
    const [showSMTP, setShowSMTP] = useState(false);
    const [encryptionType, setEncryptionType] = useState("1");
    const [selectedService, setSelectedService] = useState("Select Email Service");
    const [showPassword, setShowPassword] = useState(false);
    const [host, setHost] = useState("");
    const [port, setPort] = useState("");
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [senderEmail, setSenderEmail] = useState("");
    const [showSave, setShowSave] = useState(false);

    const toggleRolesDropdown = () => {
        setRolesVisible(!rolesVisible);
    };

    // useEffect(() => {
    //     if (config?.servertype) {
    //         const matched = emailServices.find(
    //             (s) => s.toLowerCase().replace(/\s/g, "") === config.servertype.toLowerCase().replace(/\s/g, "")
    //         );

    //         if (matched) {
    //             setSelectedService(matched);
    //             setShowSMTP(matched === "SMTP.COM");
    //         }
    //     }
    //     setEncryptionType(
    //         config.ssl ? "2" : config.tls ? "3" : "1"
    //     );
    // }, [config, emailServices]);

    const saveEmailConfig = async () => {
        let payload = {
            "servertype": selectedService,
            "senderemailid": senderEmail,
            "username": username,
            "password": password,
            "emailserver": host,
            "emailserverport": port,
            "ssl": encryptionType == "2",
            "tls": encryptionType == "3"
        }
        const resp = await postMethod(`platform/configuration/email`, payload);

        if (resp?.status === 200) {
            // setSelectedService(resp?.data?.result[0]?.emailgatewayserver?.servertype);
            // setSenderEmail(resp?.data?.result[0]?.emailgatewayserver?.senderemailid);
            // setUsername(resp?.data?.result[0]?.emailgatewayserver?.username);
            // setPassword(resp?.data?.result[0]?.emailgatewayserver?.password);
            // setHost(resp?.data?.result[0]?.emailgatewayserver?.emailserver);
            // setPort(resp?.data?.result[0]?.emailgatewayserver?.emailserverport);
            // setEncryptionType(resp?.data?.result[0]?.emailgatewayserver?.ssl ? "2" : config.tls ? "3" : "1");

            setToast(resp?.data?.message, "success");
            // setCallPlatformLicense(true);

            getPlatformDetails();
        }
        else {
            setToast(resp?.data?.message, "error");
        }
    };

    const getPlatformDetails = async () => {
        const resp = await getMethod(`platform/license`);
   
        if (resp?.data?.code === 200 && resp?.data?.result?.[0]) {
            const data = resp?.data?.result[0];

            const isEmailGatewayEmpty =
                !resp?.data?.result[0]?.emailgatewayserver ||
                Object.values(resp?.data?.result[0]?.emailgatewayserver).every(
                    value =>
                        value === null ||
                        value === undefined ||
                        value === ""
                );

            setShowSave(isEmailGatewayEmpty);

            setSelectedService(resp?.data?.result[0]?.emailgatewayserver?.servertype);
            setSenderEmail(resp?.data?.result[0]?.emailgatewayserver?.senderemailid);
            setUsername(resp?.data?.result[0]?.emailgatewayserver?.username);
            setPassword(resp?.data?.result[0]?.emailgatewayserver?.password);
            setHost(resp?.data?.result[0]?.emailgatewayserver?.emailserver);
            setPort(resp?.data?.result[0]?.emailgatewayserver?.emailserverport);
            setEncryptionType(resp?.data?.result[0]?.emailgatewayserver?.ssl ? "2" : resp?.data?.result[0]?.emailgatewayserver?.tls ? "3" : "1");

            // setToast(resp?.data?.message, "success");
        }
    };

    const hasFetchedRef = useRef(false);
    useEffect(() => {
        if (hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        getPlatformDetails();
    }, []);

    return (

        <Box>

            <Typography variant="h6" sx={{ fontWeight: 400, color: "#E2E3E3", fontSize: 14 }}>
                Email Service
            </Typography>
            <Stack
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                className={`modalForm-input`}
                style={{
                    marginBottom: "-10px",
                    cursor: "pointer",
                    width: '480px'
                }}
                onClick={toggleRolesDropdown}
            >
                <span style={{ fontSize: 14 }}>
                    {["AWS", "SMTP"].includes(selectedService) ? selectedService : selectedService
                        ?.toLowerCase()
                        .replace(/\b\w/g, (char: string) => char.toUpperCase())}
                </span>
                <ExpandMoreIcon
                    sx={{
                        cursor: "pointer",
                        color: "#B4B7B8",
                        fontSize: "24px",
                        display: "inline-block",
                        transition: "0.5s",
                    }}
                />
            </Stack>
            {rolesVisible && (
                <ClickAwayListener
                    onClickAway={() => setRolesVisible(false)}
                >
                    <div
                        className="modalForm-menu"
                        id="sitesBox"
                        style={{
                            marginTop: 12,
                            position: "absolute",
                            width: "480px",
                            maxHeight: "210px",
                            overflow: "auto",
                            scrollbarWidth: "none",
                            zIndex: 9,
                        }}
                    >
                        <FormControl>
                            {emailServices.map((service, index) => (
                                <Box
                                    key={index}
                                    onClick={() => {
                                        setRolesVisible(false);
                                        setSelectedService(service);
                                        setHost("");
                                        setPort("");
                                        setPassword("");
                                        setUsername("");
                                        setEncryptionType("1");
                                    }}
                                    sx={{
                                        cursor: "pointer",
                                        color: "#B4B7B8",
                                        p: 1,
                                        "&:hover": { backgroundColor: "#192529" },
                                        width: "450px",
                                    }}
                                >
                                    {/* {service?.toLowerCase()
                                        .replace(/\b\w/g, (char: string) => char.toUpperCase())} */}
                                        {["AWS", "SMTP"].includes(service) ? service : service?.toLowerCase()
                                        .replace(/\b\w/g, (char: string) => char.toUpperCase())}
                                </Box>
                            ))}
                        </FormControl>

                    </div>
                </ClickAwayListener>
            )}

            {/* {showSMTP && */}
            <Box sx={{ marginTop: 2 }}>

                <Grid size={{ xs: 12 }}>
                    <hr
                        style={{
                            border: "none",
                            height: "1px",
                            color: "#313838",
                            backgroundColor: "#313838",
                            margin: "30px 0 30px 0",
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 2 }}>
                    <label htmlFor="username" className="modalForm-label" style={{ color: '#FFFFFF' }}>
                        Sender Email ID<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                        type="text"
                        id="totalspace"
                        className="modalForm-input"
                        name="totalspace"
                        autoComplete="off"
                        value={
                            senderEmail
                        }
                        style={{
                            background: '#192529',
                            color: '#A5A8A9',
                        }}
                        onChange={(e) => setSenderEmail(e.target.value)}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }} sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1, fontWeight: 400, color: "#E2E3E3", fontSize: 14 }}>
                        Encryption
                    </Typography>
                    <Box sx={{ mb: 2 }} style={{ backgroundColor: "#192529", borderRadius: "30px", color: "#E2E3E3", fontSize: "14px" }}>

                        <RadioGroup
                            name="validity"
                            row
                            value={encryptionType}
                            onChange={(e: any) => setEncryptionType(e.target.value)}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="None" />
                            <FormControlLabel value="2" control={<Radio />} label="SSL" />
                            <FormControlLabel value="3" control={<Radio />} label="TLS" />
                        </RadioGroup>
                    </Box>
                </Grid>

                <div style={{ display: "flex", gap: "16px", marginTop: '26px' }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="username" className="modalForm-label" style={{ color: '#FFFFFF' }}>
                            {/* Host */}
                            Mail Server<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            id="totalspace"
                            className="modalForm-input"
                            name="totalspace"
                            autoComplete="off"
                            value={
                                host
                            }
                            style={{
                                background: '#192529',
                                // color: '#A5A8A9',
                            }}
                            onChange={(e) => setHost(e.target.value)}
                            placeholder="Enter mail server"
                        />
                    </div>
                    <div style={{ flex: 1, position: "relative" }}>
                        <label htmlFor="username" className="modalForm-label" style={{ color: '#FFFFFF' }}>
                            Port<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="number"
                            id="totalspace"
                            className="modalForm-input"
                            name="totalspace"
                            autoComplete="off"
                            value={
                                port
                            }
                            style={{
                                background: '#192529',
                                color: '#A5A8A9',
                            }}
                            onChange={(e) => setPort(e.target.value)}
                            placeholder="Enter port"
                        />
                    </div>
                </div>

                {/* <Box sx={{ display: "flex", flexDirection: "row", gap: 22, marginTop: 4 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <label
                                htmlFor="username"
                                className="modalForm-label"
                                style={{ color: "#FFFFFF" }}
                            >
                                Auto TLS
                            </label>
                            <AntSwitch
                                checked={true}
                                inputProps={{ "aria-label": "ant design" }}
                            />
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <label
                                htmlFor="username"
                                className="modalForm-label"
                                style={{ color: "#FFFFFF" }}
                            >
                                Authentication
                            </label>
                            <AntSwitch
                                checked={true}
                                inputProps={{ "aria-label": "ant design" }}
                            />
                        </Box>
                    </Box> */}


                <div style={{ display: "flex", gap: "16px", marginTop: '26px' }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="username" className="modalForm-label" style={{ color: '#FFFFFF' }}>
                            Username<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            id="totalspace"
                            className="modalForm-input"
                            name="totalspace"
                            autoComplete="off"
                            value={
                                username
                            }
                            style={{
                                background: '#192529',
                                color: '#A5A8A9',
                            }}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                        />
                    </div>

                    <div style={{ flex: 1, position: "relative" }}>
                        <label htmlFor="email" className="modalForm-label" style={{ color: '#FFFFFF' }}>
                            Password<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            id="freespace"
                            className="modalForm-input"
                            name="freespace"
                            autoComplete="off"
                            style={{
                                background: '#192529',
                                color: '#A5A8A9',
                                paddingRight: "40px",
                            }}
                            value={
                                password
                            }
                            // readOnly
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"

                        />
                        <img
                            src={showPassword ? "/open-eye.svg" : "/closed-eye.svg"}
                            alt="Toggle password visibility"
                            onClick={() => setShowPassword(prev => !prev)}
                            style={{
                                position: "absolute",
                                right: "12px",
                                top: "55%",
                                // transform: "translateY(-50%)",
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                            }}
                        />
                    </div>
                </div>
            </Box>

            <Box
                sx={{
                    // backgroundColor: "#192529",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    px: 3,
                    py: 2,
                    position: "sticky",
                    bottom: 0,
                }}
            >
                <Button
                    type="button"
                    variant="contained"
                    className="btnBlue"
                    sx={{
                        color: "#1F2F34",
                        height: "41px",
                        lineHeight: "41px",
                        borderColor: "#0B4A62",
                        background: "#0B4A62",
                        "&:hover": {
                            background: "#0E607D",
                        },
                         "&.Mui-disabled": {
                            backgroundColor: "#B0BEC5 !important",
                            color: "#6B7280",
                            cursor: "not-allowed !important",
                        },
                        borderRadius: '30px',
                        fontWeight: '500',
                        textTransform: "none",
                    }}
                    onClick={() => {
                        saveEmailConfig();
                    }}
                    disabled={!senderEmail || !host || !port || !username || !password}
                >
                    {showSave ? "Save" : "Update"}
                </Button>
            </Box>
        </Box>
    );
};

export default EmailSetup;
